module.exports = __webpack_public_path__ + "static/media/codeScreenshot.73e2fdcd.jpg";